export const PortfolioEmptyState = () => {
  return <div className='min-h-screen' data-sentry-component="PortfolioEmptyState" data-sentry-source-file="PortfolioEmptyState.tsx">
      <div className='p-4'>
        <p>No funds in this network. You can deposit from home.</p>
      </div>
    </div>;
};